/* eslint-disable */
/* this file is generated by generateIcons script */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class FileScanIcon extends BaseIcon {
  getChildren = () => [
    <path fill={ this.getColor() }
          d="M68.06,63A18,18,0,0,1,82.79,91.32l13,13A4,4,0,1,1,90.11,110l-13-13a2.15,2.15,0,0,1-.23-.28A17.8,17.8,0,0,1,68.06,99a18,18,0,0,1,0-36"/>,
    <circle fill="#fff" cx="68.06" cy="81" r="12"/>,
    <path fill={ this.getColor() }
          d="M46.06,81a22,22,0,0,1,.84-6H33.06V70H49a22.37,22.37,0,0,1,4-5H33.06V60H61.5a21.94,21.94,0,0,1,18.56,2.58V42l-19-21H28.31c-2.9,0-5.25,2.35-5.25,6.25v66.5c0,1.9,2.35,4.25,5.25,4.25h25.8A22,22,0,0,1,46.06,81Zm-13-31h36v5h-36Z"/>
  ]
  getViewBox = () => '0 0 120 120'
}
